import * as urlUtils from 'utils/Url';
import constants from 'Constants';
import { getAuth, patchAuth, postAuth, deleteAuth } from 'api/Utils';


function pathViewShoplineSettingsShforms() {
  return `view/shopline-settings-shforms`;
}

export function getViewShoplineSettingsShforms(successCallback, errorCallback, qs={}) {
  getAuth({
    "path": urlUtils.appendQueryString(pathViewShoplineSettingsShforms(), qs),
    "successCallback": successCallback,
    "errorCallback": errorCallback
  });
}

function pathShoplineSettings() {
  return `shopline-settings`;
}

export function patchShoplineSettings(successCallback, errorCallback, data) {
  patchAuth({
    "path": pathShoplineSettings(),
    "successCallback": successCallback,
    "errorCallback": errorCallback,
    "data": data
  });
}
